import {
  Component,
  Input,
  Output,
  ContentChild,
  TemplateRef,
  OnInit,
  OnChanges,
  SimpleChanges,
  EventEmitter,
  ViewChild,
  ElementRef,
  OnDestroy
} from '@angular/core';
import { Subject } from 'rxjs';

declare const $: JQueryStatic;

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss']
})
export class TableComponent implements OnInit, OnChanges, OnDestroy {
  @Input() tableTitle: string;
  @Input() tableColumnTitles: string[];
  @Input() tableData: any;
  @Input() filterColumn: number;
  @Input() rowColourClass: string;
  @Output() filteredData = new EventEmitter<any>();
  @ContentChild('table', { static: false }) tableTemplateRef: TemplateRef<any>;
  @ViewChild('dataTable', { static: false }) tableRef: ElementRef;
  dtTrigger: Subject<any> = new Subject();
  dtOptions: any = {};

  private dataTableInstance: DataTables.Api;

  ngOnInit(): void {
    this.dtOptions = {
      responsive: {
        details: {
          type: 'inline',
        }
      },
      columnDefs: [
        {
          targets: -1, //prevent last column from being responsive to keep action buttons active
          responsivePriority: 1 
        }
      ],
      dom: 'flBrtip',
      buttons: [
        {
          extend: 'excel',
          text: 'Download Excel',
          exportOptions: {
            columns: (index: number, data: any, node: any) => {
              const headerText = this.tableColumnTitles[index];
              return !headerText.includes('Action') && !headerText.includes('Edit Role');
            }
          }
        },
        {
          extend: 'pdf',
          text: 'Download PDF',
          exportOptions: {
            columns: (index: number, data: any, node: any) => {
              const headerText = this.tableColumnTitles[index];
              return !headerText.includes('Action') && !headerText.includes('Edit Role');
            }
          }
        }
      ],
      destroy: true,
      retrieve: true
    };
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['tableData'] && !changes['tableData'].firstChange) {
      if (this.dataTableInstance) {
        this.dataTableInstance.clear().destroy();
      }
      // TODO: find a way to delay the execution other than the setTimeout.. SetTimeout may not work on all devices
      setTimeout(() => {
        if (this.tableRef?.nativeElement) {
          this.dataTableInstance = $(this.tableRef.nativeElement).DataTable(this.dtOptions);
        }
      }, 0);
    }
  }

  ngOnDestroy(): void {
    if (this.dataTableInstance) {
      this.dataTableInstance.destroy();
    }
  }
}
